<div class="not-found">
  <h1>We can't find the page you are looking for</h1>
  <p>
    The page may have moved, or the URL might be mistyped. Please return to our
    homepage to keep browsing
  </p>
  <rsc-asp-button
    [buttonLabel]="'Go to Homepage'"
    [redirectUrl]="'/'"
    [openInNewTab]="false"
  >
  </rsc-asp-button>
</div>
